import { ActionReducer, createFeatureSelector, createReducer, createSelector, MemoizedSelector, on } from '@ngrx/store';

import { GuestCartActions } from '../actions';
import { IGuestCart, IGuestCartResponse } from '../models/guest.models';
import { PayloadUtils } from '../utils/payload.utils';
import { GuestUtils } from '../utils/guest.utils';
import { IAddress } from '../models/common.models';
import { ICartAttributes } from '../models/cart.models';
import { ICustomerCheckoutData } from '../models/customer.models';

export interface GuestCartState {
  guestCart: IGuestCart | null,
}

export const initialState: GuestCartState = {
  guestCart: null,
};

export const guestCartBaseState: MemoizedSelector<object, GuestCartState> = createFeatureSelector<GuestCartState>('guestCart');

export const selectGuestCart: MemoizedSelector<object, IGuestCart | null> = createSelector(
  guestCartBaseState,
  (state: GuestCartState) => state.guestCart,
);

export const selectAddressFromGuestCart: MemoizedSelector<object, IAddress | null> = createSelector(
  guestCartBaseState,
  (state: GuestCartState) => state.guestCart ? GuestUtils.createIAddressFromIGuestCart(state.guestCart) : null,
);

export const selectCustomerCheckoutDataFromGuestCart: MemoizedSelector<object, ICustomerCheckoutData | null> = createSelector(
  guestCartBaseState,
  (state: GuestCartState) => state.guestCart ? GuestUtils.createICustomerCheckoutDataFromIGuestCart(state.guestCart) : null,
);

export const selectCartAttributesFromGuestCart: MemoizedSelector<object, ICartAttributes | null> = createSelector(
  guestCartBaseState,
  (state: GuestCartState) => state.guestCart ? GuestUtils.createICartAttributesFromIGuestCart(state.guestCart) : null,
);

export const GuestCartReducer: ActionReducer<GuestCartState> = createReducer(
  initialState,
  on(GuestCartActions.loadGuestCart, (state: GuestCartState) => {
    return {
      ...state,
      guestCart: null,
    };
  }),
  on(GuestCartActions.loadGuestCartSuccess, (state: GuestCartState, action) => {
    return {
      ...state,
      guestCart: mapIGuestCartResponseToIGuestCart(action.guestCartResponse),
    };
  }),
);

function mapIGuestCartResponseToIGuestCart(guestCartResponse: IGuestCartResponse): IGuestCart {
  return {
    data: guestCartResponse.data,
    items: guestCartResponse.included ? PayloadUtils.getItemsWithDetailsFromInclude(
      guestCartResponse.included,
      false,
      ['concrete-products', 'concrete-product-image-sets', 'guest-cart-items'],
      'guest-cart-items',
    ) : [],
  };
}
